import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import PropTypes from 'prop-types';
// import CheckoutForm from './checkout-form';
import PaymentMethodComponent from './PaymentMethod';

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe('pk_live_51I8sENGgw4UQroOgQcCkENbeBgW4mXrp0y20HmunSceMaU2XFuaVwtfJ9X05Q0YD8xXxsUf5KuLACQudRNNQvXvB00pMVsaPLF');

const StripePaymentComponent = ({ token, address, userId, getCardData }) => {
  // const options = {
  //   // passing the client secret obtained from the server
  //   clientSecret: '{{CLIENT_SECRET}}',
  // };

  return (
    <Elements stripe={stripePromise}>
      <PaymentMethodComponent token={token} address={address} userId={userId} getCardInfo={getCardData} />
    </Elements>
  );
};

StripePaymentComponent.propTypes = {
  token: PropTypes.string,
  address: PropTypes.object,
  userId: PropTypes.string,
  getCardData: PropTypes.func.isRequired
};

export default StripePaymentComponent;
